import templateUrl from "emun.order/order-editable-kit.htm";
import OrderEditableKitController from "emun.order/order-editable-kit.controller";
import open from "webmodals/open";

let OrderEditableKit = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderEditableKitController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderEditableKit;
